
<template>
  <div>
    <page-header>
      <template slot="title"> Informações da Empresa 🏢</template>
    </page-header>
    <card-loading-transparent v-if="loading"></card-loading-transparent>

    <template v-if="!loading && company">
      <v-row >
        <v-col v-if="$vuetify.breakpoint.smAndDown" class="pb-0">
          <div class="text-center">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn class="btn-primary" v-bind="attrs" v-on="on" block text dense>
                  <v-icon left >mdi-menu</v-icon>
                  <span>MENU</span>
                </v-btn>
              </template>
              <v-list dense nav small>
                <v-list-item-group v-model="selected_item" color="btn-primary" mandatory>
                  <div v-for="item in menus" :key="item.title">
                    <v-list-item 
                      :disabled="!item.is_link || disable_btn" 
                      color="black" 
                      :link="item.is_link" 
                      :class="['my-1', item.is_link ? 'menu-mobile' : 'primary title']" 
                      :dark="!item.is_link"                      
                    >
                      <v-list-item-content class="py-0">
                        <v-list-item-title :class="item.is_link ? 'ml-6' : ''" @click="item.action">
                          <v-icon class="mb-1">{{item.icon}}</v-icon> {{item.title}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      
        <v-col cols="12" md="3" :class="$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''" v-if="!$vuetify.breakpoint.smAndDown">
          
          <default-card>

            <template slot="title-left">
               Menu 📟
            </template>
            <template slot="content">
              <!-- <v-list dense nav >
                <v-list-item-group v-model="selected_item" color="primary darken-4" mandatory>
                  <div v-for="item in menus" :key="item.title">
                    <v-list-item 
                      :disabled="!item.is_link || disable_btn" 
                      color="primary" 
                      :link="item.is_link" 
                      :class="['my-1', item.is_link ? '' : 'primary title']" 
                      :dark="!item.is_link"
                    >
                      <v-list-item-content>
                        <v-list-item-title :class="item.is_link ? 'ml-6' : ''" @click="item.action">
                          <v-icon class="mb-1">{{item.icon}}</v-icon> {{item.title}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-list> -->
            </template>
            <template slot="content">
              <v-row min-width="100%">
                <v-col class="px-0 pt-0">
                  <v-card outlined class="ma-3">
                    <v-card-title class="text-subtitle-2 primary--text py-0 px-2">
                      Geral
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn 
                        color="black" text dense
                        :class="['btn-secondary px-3 mb-1', $route.name == 'MyCompanySettings' ? 'btn-secondary-active' : '' ]" 
                        @click="showSettings({name: 'MyCompanySettings', params: {}})"
                      > Empresa </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card outlined class="ma-3">
                    <v-card-title class="text-subtitle-2 primary--text py-0 px-2">
                      Financeiro
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <div :class="$vuetify.breakpoint.smAndDown ? 'd-flex flex-column' : ''">
                        <v-btn v-if="false" color="black" text dense
                          :class="['btn-secondary px-3 mr-3 mb-1', $route.name == 'MyCompanyFinancialReserve' ? 'btn-secondary-active' : '' ]" 
                          @click="showSettings({name: 'MyCompanyFinancialReserve', params: {}})"
                        > Reserva do mês </v-btn>
                        <v-btn 
                          color="black" text dense
                          :class="['btn-secondary px-3 mb-1', $route.name == 'MyCompanyFinancialGoal' ? 'btn-secondary-active' : '' ]" 
                          @click="showSettings({name: 'MyCompanyFinancialGoal', params: {}}) "
                        > Meta do mês </v-btn>
                      </div>
                    </v-card-actions>
                  </v-card>
                  <v-card outlined class="ma-3">
                    <v-card-title class="text-subtitle-2 primary--text py-0 px-2">
                      Usuários
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn 
                        color="black" text dense
                        :class="['btn-secondary px-3 mb-1', $route.name == 'MyCompanyMemberList' ? 'btn-secondary-active' : '' ]" 
                        @click="showSettings({name: 'MyCompanyMemberList', params: {}}) "
                      > Equipe </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </default-card>
        </v-col>
        
        <v-col cols="12" md="9">
          <router-view></router-view>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'CompanyInfo',
  components: {
    RegisterCompany: ()=>import('./RegisterCompany.vue'),
    CompanyFinancialSettings: ()=>import('./CompanyFinancialSettings/CompanyFinancialSettings.vue'),
  },
  data() {
    return {
      tabs: null,
      loading: false,
      company: {},
      company_financial: {},
      menus: [
        { 
          is_link: false,
          selectable_disabled: true,
          icon: 'mdi-cog',
          title: 'Geral',
          value: 'geral',
          action: () => {} 
        },
        { 
          is_link: true,
          selectable_disabled: false,
          icon: 'mdi-circle-small',
          title: 'Empresa',
          value: 'company',
          action: () => this.showSettings({name: 'MyCompanySettings', params: {}}) 
        },
        { 
          is_link: false,
          selectable_disabled: true,
          icon: 'mdi-cash',
          title: 'Financeiro',
          value: 'finance_info',
          action: () => {}
        },
        // { 
        //   is_link: true,
        //   selectable_disabled: false,
        //   icon: 'mdi-circle-small',
        //   title: 'Reserva do mês',
        //   value: 'reserve',
        //   action: () => this.showSettings({name: 'MyCompanyFinancialReserve', params: {}}) 
        // },
        { 
          is_link: true,
          selectable_disabled: false,
          icon: 'mdi-circle-small',
          title: 'Meta do mês',
          value: 'goal',
          action: () => this.showSettings({name: 'MyCompanyFinancialGoal', params: {}}) 
        },
        { 
          is_link: false,
          selectable_disabled: true,
          icon: 'mdi-account',
          title: 'Usuários',
          value: 'users',
          action: () => {}
        },
        { 
          is_link: true,
          selectable_disabled: false,
          icon: 'mdi-circle-small',
          title: 'Integrantes/Cargos',
          value: 'members',
          action: () => this.showSettings({name: 'MyCompanyMemberList', params: {}}) 
        },
      ],
      disable_btn: false,
      selected_item: null,
      selected_menu: '',
    }
  },
  mounted() {
    this.checkSelectedItemMenu()
  },
  methods: {
    showSettings(route){
      this.disable_btn = true
      this.$router.push({name: route.name, params: route.params}).catch(()=>{});
      setTimeout(() => {
        this.disable_btn = false
      }, 500);
    },
    checkSelectedItemMenu(){
      return this.selected_item = (this.$route.name == 'MyCompanySettings') ? 1 : 
      (this.$route.name == 'MyCompanyFinancialReserve') ? 3 :
      (this.$route.name == 'MyCompanyFinancialGoal') ? 4 : 
      (this.$route.name == 'MyCompanyMemberList') ? 6 : 0
    },
    // getCompany() {
    //   this.loading = true
    //   if(this.activeCompanyId){
    //     Api.Company.show(this.activeCompanyId).then(r => r.data).then(company => {
    //       this.company = company
    //     }).catch((err) => {
    //       noti = {
    //         type: 'error',
    //         msg: `Erro: ${err}`
    //       }
    //       console.log({err});
    //       // this.addNotification(noti)
    //     }).finally(()=>{
    //       this.getCompanyFinancial()
    //     })
    //   }
    // },
    // getCompanyFinancial(){
    //   let filter_company_financial = {
    //     company_id: this.activeCompanyId
    //   }
    //   Api.CompanyFinancial.index(filter_company_financial).then(r => r.data).then(company_financial => {
    //     this.company_financial = company_financial[0]
    //   }).catch((err) => {
    //     noti = {
    //       type: 'error',
    //       msg: `Erro: ${err}`
    //     }
    //     console.log({err});
    //     // this.addNotification(noti)
    //   }).finally(()=>{
    //     this.loading = false
    //   })
    // },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    //selected_item() {
      
      // (this.$route.name == 'MyCompanySettings') ? return 1 :
      // (this.$route.name == 'MyCompanyFinancialReserve') ? return 3 :
      // (this.$route.name == 'MyCompanyFinancialGoal') ? menu_selected_idx = 4 : 
      // (this.$route.name == 'MyCompanyMemberList') ? menu_selected_idx = 6 : null

    //},
    ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
    }),
  },
  watch: {
    activeCompanyId(){
      //this.getCompany()
    }
  },
}
</script>

<style scoped>

.v-list-item {
  color: rgb(27, 27, 27);
}

.title{
  color: white
}

.menu-mobile{
  background-color: rgba(21, 135, 211, 0.2) !important
  
}

</style>